import React from "react";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer as ToastifyContainer } from "react-toastify/unstyled";
import CloseButton from "./CloseButton";
const ToastContainer = () => {
    return (React.createElement(ToastifyContainer, { theme: "light", icon: false, closeButton: CloseButton, closeOnClick: true, position: "top-right", autoClose: 5000 }));
};
export default ToastContainer;
//# sourceMappingURL=ToastContainer.js.map